<template>
  <section class="alerts">
    <header class="alerts-head">
      <span class="alerts-icon"><PortalIcon name="alert" :size="18" /></span>
      <h3 class="alerts-title">
        {{ alerts.length === 1 ? "Tiene 1 documento por actualizar" : `Tiene ${alerts.length} documentos por actualizar` }}
      </h3>
    </header>
    <ul class="alert-list">
      <li v-for="row in alerts" :key="row.key" class="alert-row">
        <div class="alert-top">
          <div class="alert-name">{{ row.label }}</div>
          <StatusBadge :tone="row.status.tone" :label="row.status.label" />
        </div>
        <p class="alert-text">
          {{ row.status.detail }}.
          {{
            row.status.tone === "danger"
              ? "Suba el documento renovado para mantener su expediente al día."
              : "Cuando lo renueve, suba el documento nuevo."
          }}
        </p>
        <button
          type="button"
          class="btn-small"
          :class="{ 'btn-small-primary': row.status.tone === 'danger' }"
          @click="$emit('edit', 1)"
        >
          Actualizar
        </button>
      </li>
    </ul>
  </section>
</template>

<script>
import PortalIcon from "./PortalIcon.vue";
import StatusBadge from "./StatusBadge.vue";

// The documents that are about to expire or already did (documentAlerts() rows): a plain white card, orange only in
// the icon and the badges, with a button on each one to renew it.
export default {
  name: "PortalAlertsCard",
  components: { PortalIcon, StatusBadge },
  props: {
    alerts: { type: Array, required: true },
  },
};
</script>

<style scoped>
.alerts {
  /* Same stacking layer as the (positioned) credential card, so each card covers the shadow of the one above. */
  position: relative;
  border-radius: 20px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(10, 16, 32, 0.05), 0 8px 24px -10px rgba(10, 16, 32, 0.14);
}
.alerts-head {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 18px 20px 16px;
}
.alerts-icon {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff1e2;
  box-shadow: inset 0 0 0 1px #fad9b0;
  color: #b4540a;
}
.alerts-icon svg {
  stroke-width: 2.2;
}
.alerts-title {
  margin: 0;
  font: 600 15px/1.35 "Geist", system-ui, sans-serif;
  color: #0e1424;
  text-wrap: balance;
}
.alert-list {
  margin: 0;
  padding: 0;
  list-style: none;
}
.alert-row {
  padding: 16px 20px 18px;
  border-top: 1px solid #f0f2f5;
}
.alert-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}
.alert-name {
  min-width: 0;
  font: 600 14px/1.35 "Geist", system-ui, sans-serif;
  color: #0e1424;
}
/* The badge, a notch smaller than the summary's. */
.alert-top .status-badge {
  flex-shrink: 0;
  min-width: 0;
  height: 22px;
  padding: 0 8px;
  font-size: 11.5px;
}
.alert-text {
  margin: 6px 0 12px;
  font: 400 13px/1.5 "Geist", system-ui, sans-serif;
  color: #6b7283;
  text-wrap: pretty;
}
.btn-small {
  height: 36px;
  padding: 0 16px;
  border: 1px solid #e3e6ed;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(10, 16, 32, 0.06);
  font: 600 13px "Geist", system-ui, sans-serif;
  color: #0e1424;
  cursor: pointer;
}
.btn-small:hover {
  background: #f4f5f8;
}
.btn-small.btn-small-primary {
  border: 0;
  background: #0e1424;
  box-shadow: 0 6px 14px -6px rgba(10, 16, 32, 0.6);
  color: #fff;
}
.btn-small.btn-small-primary:hover {
  background: #24304d;
}

@media (max-width: 640px) {
  .btn-small {
    width: 100%;
  }
}
</style>
